import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import mission1 from '../../images/causes/9.jpg';
import mission2 from '../../images/causes/10.jpg';
import mission3 from '../../images/causes/6.jpg';
import mission4 from '../../images/causes/11.jpg';
import mission5 from '../../images/causes/4.jpg';
import mission6 from '../../images/causes/13.jpg';
import mission7 from '../../images/causes/14.jpg';
import mission9 from '../../images/causes/16.jpg';
import mission8 from '../../images/causes/18.jpg';
import mission10 from '../../images/causes/21.png';
import { Link } from 'react-router-dom';

const MissionsSection = () => {
  const missions = [
    {
      id: 'Campaign-Jigjiga',
      title: 'Addis Ababa, Ethiopia Cardiac Mission',
      description:
        'Italian medical team with Ethio-Istanbul General Hospital',
      image: mission1, 
      imageAlt: 'Education icon',
      link: 'mission/ethio-istanbul-campaign',
    },
    {
      id: 'capacity-building',
      title: 'Jigjiga, Ethiopia Cardiac Mission',
      description:
        'Italian medical team with Ethio-Istanbul General Hospital',
      image: mission2,
      imageAlt: 'Capacity building icon',
      link: '/mission/campaign-ethio-istanbul-italy',
    },
    // {
    //   id: 'Campaign-Jigjiga',
    //   title: 'Jigjiga Cardiac Mission ',
    //   description:
    //     'By Ethio-Istanbul General Hospital Medical Team',
    //   image: mission3, 
    //   imageAlt: 'Education icon',
    //   link: '/mission/campaign-jigjiga',
    // },
    {
      id: 'capacity-building',
      title: 'Jimma, Ethiopia Cardiac Mission',
      description:
        'By Ethio-Istanbul General Hospital',
      image: mission6,
      imageAlt: 'Capacity building icon',
      link: 'mission/campaign-jimma',
    },
     {
      id: 'capacity-building',
      title: 'Gondar, Ethiopia Cardiac Mission',
      description:
        'Italian specialists team with  Ethio-Istanbul General Hospital',
      image: mission10,
      imageAlt: 'Capacity building icon',
      link: 'mission/campaign-gondar',
    },
    {
      id: 'quality-healthcare',
      title: 'St. Paul’s, Addis Ababa Cardiac Mission',
      description:
        'Free Pediatric Cardiac Surgeries at St. Paul’s Hospital Millennium Medical College',
      image: mission9,
      imageAlt: 'Healthcare icon',

    },
     {
      id: 'capacity-building',
      title: 'Tikur Anbessa, Addis Ababa Cardiac Mission',
      description:
        'Free Pediatric Cardiac Surgeries at Tikur Anbessa Specialized Hospital',
      image: mission8,
      imageAlt: 'Capacity building icon',
    },
    {
      id: 'quality-healthcare',
      title: 'Cardiac Center - Ethiopian Cardiac Mission',
      description:
        'Free Pediatric Cardiac Surgeries at The Cardiac Center Ethiopia (Lib Makel)',
      image: mission7,
      imageAlt: 'Healthcare icon',
    },
    {
      id: 'capacity-building',
      title: 'Ethiopian New Year 2018 Cardiac Mission ',
      description:
        'Free cardiac surgery at Ethio-Istanbul General Hospital',
      image: mission4,
      imageAlt: 'Capacity building icon',
      link: 'mission/new-year-2025',
    },
    {
      id: 'quality-healthcare',
      title: 'Ethiopian New Year 2017 Cardiac Mission',
      description:
        'Free cardiac surgery at Ethio-Istanbul General Hospital',
      image: mission5,
      imageAlt: 'Healthcare icon',
      link: 'mission/new-year-2024',
    },
  ];

  // Split missions into first row (3 items) and second row (2 items)
  const firstRowMissions = missions.slice(0, 3);
  const secondRowMissions = missions.slice(3, 9);

  return (
    <section className="missions-section py-5" style={{ backgroundColor: '#f8f9fa' }}>
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-5">
          <h2 className="display-5 fw-bold text-dark mb-3">Cardiac Missions</h2>
          <div
            className="mx-auto rounded-pill"
            style={{
              width: '80px',
              height: '4px',
              backgroundColor: '#066897',
              marginBottom: '1rem',
            }}
          />
          <p className="text-secondary mx-auto" style={{ maxWidth: '600px' }}>
            Committed to creating lasting change through focused initiatives
          </p>
        </div>

        {/* First Row - 3 cards */}
        <div className="row g-4 mb-4">
          {firstRowMissions.map((mission) => (
            <div key={mission.id} className="col-md-6 col-lg-4">
              <div
                className="card h-100 border-0 shadow-sm transition-all"
                style={{
                  borderRadius: '16px',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 1rem 2rem rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,0.075)';
                }}
              >
                <div className="card-body p-4">
                  <div
                    className="rounded-3 d-inline-flex align-items-center justify-content-center mb-4 overflow-hidden"
                    style={{
                      borderRadius: '16px',
                      transition: 'background-color 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#b02a37';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#dc3545';
                    }}
                  >
                    <img
                      src={mission.image}
                      alt={mission.imageAlt}
                      style={{
                        objectFit: 'contain',
                      }}
                    />
                  </div>

                  <h3 className="h4 fw-bold text-dark mb-3">{mission.title}</h3>
                                      <h3 className="h5 fw-bold text-dark ">{mission.description}</h3>

                  <div className="d-flex flex-column align-items-center">
                    <Link to={mission.link} className="mt-2 fw-bold" style={{color:'#066897'}}>
                      Read More <i className="fas fa-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Second Row - 2 cards centered */}
        <div className="row g-4 justify-content-center">
          {secondRowMissions.map((mission) => (
            <div key={mission.id} className="col-md-6 col-lg-4">
              <div
                className="card h-100 border-0 shadow-sm transition-all"
                style={{
                  borderRadius: '16px',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  cursor: 'pointer',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-4px)';
                  e.currentTarget.style.boxShadow = '0 1rem 2rem rgba(0,0,0,0.1)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,0.075)';
                }}
              >
                <div className="card-body p-4">
                  <div
                    className="rounded-3 d-inline-flex align-items-center justify-content-center mb-4 overflow-hidden"
                    style={{
                      borderRadius: '16px',
                      transition: 'background-color 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#b02a37';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#dc3545';
                    }}
                  >
                    <img
                      src={mission.image}
                      alt={mission.imageAlt}
                      style={{
                        objectFit: 'contain',
                      }}
                    />
                  </div>

                  <h3 className="h4 fw-bold  mb-3">{mission.title}</h3>
                    <h3 className="h5 fw-bold text-dark ">{mission.description}</h3>
{mission.link && (
                    <div className="d-flex flex-column align-items-center">
                      <Link to={mission.link} className="mt-2 fw-bold" style={{color:'#066897'}}>
                        Read More <i className="fas fa-arrow-right"></i>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MissionsSection;